// `[` / `{` let server-resolved placeholders like `{{merge_field}}` survive sanitization.
export const SAFE_HREF_REGEXP = /^(?:https?:\/\/|\/\/|mailto:|tel:|[[{])/i;

// Requiring a dot before the numeric port keeps `javascript:alert(1)` from reading as `host:port`.
export const BARE_DOMAIN_REGEXP =
  /^[\p{L}\p{N}](?:[\p{L}\p{M}\p{N}-]*[\p{L}\p{M}\p{N}])?(?:\.[\p{L}\p{N}](?:[\p{L}\p{M}\p{N}-]*[\p{L}\p{M}\p{N}])?)+(?::\d{1,5})?(?:[/?#].*)?$/iu;
